module.exports = __webpack_public_path__ + "img/news-03-06-2024.af0f09b8.jpg";